<template>
    <modal
        v-if="quickPayerEdit"
        :title="$t('OrderCurrent.actions.updatePayer')"
        @close-request="onCloseUpdatePayer()"
        closable
      >
        <table-element
          :isShowFilter="false"
          :title="$t('OrderCurrent.modal.selected_orders')"
          :fields="fieldsObjPayerUpdate"
          :arrOfElement="selectedFull"
          :sortSpacing="0"
          class="card mx-2 mt-4"
        >
          <template #header-actions>
            <p class="m-2 mb-0 mt-2">{{$t('OrderCurrent.count')}} {{selectedFull.length}}</p>
          </template>

          <template #pre-body-content>
            <div class="m-3 w-25">
              <regular-datalist 
                :value="datalist.billing" 
                @input="onSelectPayer($event)"
                :originalList="clientAccounts" 
                :placeholder="$t('OrderPending.pickupDeliveryTab.name')" 
                class="form-group" 
              />
              <button class="btn btn-kne-orange" @click="onUpdatePayer">{{$t('OrderCurrent.actions.updateAllPayers')}} </button>
            </div>
          </template>

          <template #body-content-desktop="content">
            <!-- List of orders -->
            <tr v-for="(order, index) in content.results"
            class="table-element_hover text-center"
            :key="index"
            :class="{
              'drop': order.status === 'Drop',
              'cancel': order.status === 'Cancel',
              'waiting': order.status === 'Attente',
              'pick': order.status === 'Pick',
              'transit': order.status === 'Transit',
              'dispatch': order.status === 'Dispatch',
              'reject': order.status === 'Reject',
              'inspection': order.status === 'Inspection',
              'transfered': order.status === 'Transférée'
              }">
              <td class="pt-2">
                {{order.orderNumber}}
              </td>
              <td class="pt-2">
                {{order.vin || '-'}}
              </td>
              <td class="pt-2">
                <div>{{shortenString($realName(order, 'payer')) || '-'}}</div>
              </td>
              <td class="pt-2">
                <div>{{shortenString($realName(order, 'transmitter')) || '-'}}</div>
              </td>
              <td class="pt-2">
                <div>{{shortenString($realName(order, 'receiver')) || '-'}}</div>
              </td>
            </tr>
          </template>

          <template #post-body-content>
            <div class="mt-2">
              <p class="mx-2 red-text text-right">{{feedbackMessage}}</p>
              <button @click="onCloseUpdatePayer()" class="float-right btn btn-danger m-2">{{$t('OrderCurrent.modal.cancel')}}</button>
            </div>
          </template>

        </table-element>
    </modal>
</template>

<script>
import Modal from '../../interface-components/Modal.vue'
import TableElement from '../Table-component/Table-Element.vue'
import regularInput from '../../basic-components/regularInput.vue'
import { db } from '../../../../firebase'
import { clearIdentity } from '../../../../utils/orderIdentity'

export default {
    name: 'UpdatePayerModal',
    components: {
        Modal,
        TableElement,
        regularInput
    },

    data () {
        return {
            fieldsObjPayerUpdate: [
                {
                    text: this.$t('OrderCurrent.order'),
                    type: 'orderNumber',
                    value: ''
                },
                {
                    text: this.$t('OrderCurrent.VIN'),
                    type: 'VIN',
                    value: ''
                },
                {
                    text: this.$t('OrderCurrent.payer'),
                    type: 'payerName',
                    value: ''
                },
                {
                    text: this.$t('OrderCurrent.pickup'),
                    type: 'transmitterName',
                    value: ''
                },
                {
                    text: this.$t('OrderCurrent.delivery'),
                    type: 'receiverName',
                    value: ''
                }
            ],
            datalist: {
              pickup: '',
              pickupUid: '',
              delivery: '',
              deliveryUid: '',
              billing: '',
              billingUid: ''
            },
            feedbackMessage: ''
        }
    },

    props: {
        quickPayerEdit: Boolean,
        arrOfOrder: {
          type: Array,
          required: true
        },
        clientAccounts: {
          type: Object,
          required: true
        }
    },

    methods: {
        getCompanyFuelCharge () {
            const userInfo = this.$store.state.userInfo || {}
            return userInfo.fuelCharge !== undefined && userInfo.fuelCharge !== null && userInfo.fuelCharge !== ''
              ? userInfo.fuelCharge
              : 0
        },
        getClientFuelCharge (client) {
            return client && client.fuelCharge !== undefined && client.fuelCharge !== null && client.fuelCharge !== ''
              ? client.fuelCharge
              : this.getCompanyFuelCharge()
        },
        onSelectPayer (event) {
            this.datalist.billing = event.value
            this.datalist.billingUid = event.key
            if (event.key !== null) {
              db.ref('users/dealers/').child(this.datalist.billingUid).once('value').then((snap) => {
                  if (!snap.exists()) return
                  let selectedClient = snap.val()
                  this.selectedFull.forEach((order) => {
                  if (selectedClient.contacts) {
                      order.payerContact = selectedClient.contacts
                  }
                  clearIdentity(order, 'payer')
                  order.payerName = selectedClient.name
                  order.payerAddress = selectedClient.address
                  order.payerCity = selectedClient.city
                  order.payerPostcode = selectedClient.postcode
                  order.payerPhone = selectedClient.phone
                  order.payerEmail = selectedClient.email || ''
                  order.payerFax = selectedClient.fax
                  order.payerProvince = selectedClient.province
                  order.payerCountry = selectedClient.country
                  const applyFuelCharge = selectedClient.applyFuelCharge !== undefined ? selectedClient.applyFuelCharge : true
                  this.$set(order, 'applyFuelCharge', applyFuelCharge)
                  this.$set(order, 'includedFuelCharge', applyFuelCharge === false)
                  this.$set(order, 'fuelCharge', this.getClientFuelCharge(selectedClient))
                  this.$set(order, 'payerOdooPartnerId', selectedClient.odooPartnerId || '')
                  this.$set(order, 'payerOdooPartnerName', selectedClient.odooPartnerName || '')
                  this.$set(order, 'zeroTax', selectedClient.zeroTax === true)
                  this.$set(order, 'payerZone', '')
                  this.$set(order, 'payerZoneId', '')
                  order.payer = this.datalist.billingUid
                    this.calculateTravelDistance(order)
                  })
              }).catch(function (error) {
                  console.log(error)
              })
            }
        },
        calculateTravelDistance (order) {
            const originLat = order.transmitterLat
            const originLng = order.transmitterLong
            const destLat = order.receiverLat
            const destLng = order.receiverLong
            const mode = 'DRIVING'
            let google = this.google
            if (!google) return
            if (!originLat || !originLng || !destLat || !destLng) return
            return new Promise((resolve, reject) => {
                const directionsService = new google.maps.DirectionsService()

                const origin = new google.maps.LatLng(originLat, originLng)
                const destination = new google.maps.LatLng(destLat, destLng)

                const request = {
                  origin: origin,
                  destination: destination,
                  travelMode: google.maps.TravelMode[mode]
                }

                directionsService.route(request, (result, status) => {
                  if (status === google.maps.DirectionsStatus.OK) {
                      const route = result.routes[0]
                      let totalDistance = 0

                      for (let i = 0; i < route.legs.length; i++) {
                        totalDistance += route.legs[i].distance.value
                      }
                      // Convert distance from meters to kilometers
                      const distanceInKm = totalDistance / 1000
                      order.distance = distanceInKm
                      resolve(distanceInKm)
                  } else {
                      reject('Unable to calculate travel distance')
                  }
                })
            })
        },
        onUpdatePayer () {
            this.selectedFull.forEach(order => {
                const cleanOrder = { ...order }
                delete cleanOrder['.key']

                db.ref('database/transporter/' + this.companyUID + '/deliveries/' + order.orderNumber).update(cleanOrder)
            })

            this.onCloseUpdatePayer()
        },
        onCloseUpdatePayer () {
            this.$emit('closePayerModal')
        },
        shortenString (text) {
            if (typeof text === 'undefined') return text
            else {
                let subString = text.substring(0, 22)
                if (text.length > 22) subString += '...'
                return subString
            }
        }
    },

    computed: {
      companyUID () {
        return this.$store.state.authorization.company
      },
      uid () {
        return this.$store.state.user.uid
      },
      userInfo () {
        return this.$store.state.userInfo
      }
    },

    watch: {
        arrOfOrder: {
            immediate: true,
            handler (val) {
                this.selectedFull = Array.isArray(val) ? val : []
            }
        }
    }
}
</script>
